module.exports = __webpack_public_path__ + "static/img/b1.b99d280.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/b1.png
// module id = r9ri
// module chunks = 0